import { Form } from 'antd'
import React from 'react'

const AddSubscription = () => {
  return (
    <div style={{marginTop:"4rem"}} >
        <h1>Add Subscription</h1>
        <div className='my-5' >
            <Form>
                <Form.Item>

                </Form.Item>
                <Form.Item>
                    
                </Form.Item>
            </Form>
        </div>
    </div>
  )
}

export default AddSubscription